export const REFRESH_INFO = 'refreshInfoBatch';
export const UPDATE_SETTING = 'updateSetting';
export const FIRMWARE_UPGRADE = 'firmwareUpgrade';
export const PROGRESS = 'progress';
export const RUN_COMMAND = 'runCommand';
export const DATA_COLLECTION = 'dataCollection';
export const RESET_DEVICE = 'resetDevice';
